import { Box, Button } from "@mui/material";
import { assets } from "../../assets";
import { colors } from "../ui/colors";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

let didAnimateSignin = false;

export default function SigninupLayout({ children }) {
  const flownectLogo = assets.images.flownectLogo;
  const location = useLocation();
  const navigate = useNavigate();

  const isSigninRoot = location.pathname === "/signin";

  const [taglineVisible, setTaglineVisible] = useState(!isSigninRoot || didAnimateSignin);
  const [logoVisible, setLogoVisible] = useState(!isSigninRoot || didAnimateSignin);

  const [animate, setAnimate] = useState(isSigninRoot && !didAnimateSignin);

  useEffect(() => {
    if (isSigninRoot && !didAnimateSignin) {
      setAnimate(true);
      const t1 = setTimeout(() => setTaglineVisible(true), 150);
      const t2 = setTimeout(() => setLogoVisible(true), 200);
      didAnimateSignin = true;

      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    } else {
      setAnimate(false);
      setTaglineVisible(true);
      setLogoVisible(true);
    }
  }, [isSigninRoot]);

  return (
    <Box
      sx={{
        display: "flex",
        margin: 0,
        padding: 0,
        minHeight: "100vh",
      }}
    >
      {/* Panel izquierdo */}
      <Box
        sx={{
          width: { xs: "0%", md: "0%", lg: "55%" },
          flexShrink: 0,
          position: "relative",
          display: { xs: "none", md: "none", lg: "flex" },
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            width: 1600,
            height: 1600,
            borderRadius: "50%",
            background: `conic-gradient(
              transparent 0deg,
              transparent 30deg,
              ${colors.orange[500]} 30deg,
              ${colors.yellow[500]} 240deg,
              transparent 220deg
            )`,
            opacity: 0.3,
            transform: "scaleX(-1)",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />
        {/* Círculo central blanco */}
        <Box
          sx={{
            position: "relative",
            width: 800,
            height: 800,
            borderRadius: "50%",
            backgroundColor: "var(--fx-surface-brandspot, #FFFFFF)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          {/* Logo */}
          <img
            alt="Flownect"
            src={flownectLogo}
            style={{
              maxWidth: "700px",
              maxHeight: "300px",
              objectFit: "contain",
              marginBottom: "16px",
              opacity: logoVisible ? 1 : 0,
              transform: logoVisible ? "translateY(0)" : "translateY(20px)",
              transition: animate ? "opacity 300ms ease, transform 300ms ease" : "none",
            }}
          />

          {/* Tagline */}
          <Box
            component="span"
            sx={{
              color: "var(--fx-surface-onbrandspot, #0C0C0C)",
              fontSize: "32px",
              fontWeight: 900,
              textAlign: "center",
              letterSpacing: "0.5px",
              opacity: taglineVisible ? 1 : 0,
              transform: taglineVisible ? "translateY(0)" : "translateY(10px)",
              transition: animate ? "opacity 300ms ease, transform 300ms ease" : "none",
            }}
          >
            Where Flow Meets Connection
          </Box>

          <Button
            variant="outlined"
            onClick={() => navigate("/flow-hub")}
            sx={{
              mt: 3,
              px: 2.5,
              py: 0.75,
              borderRadius: "999px",
              borderColor: colors.orange[500],
              color: "var(--fx-surface-onbrandspot, #0C0C0C)",
              fontSize: "0.82rem",
              fontWeight: 700,
              letterSpacing: "0.02em",
              textTransform: "none",
              opacity: taglineVisible ? 0.9 : 0,
              transform: taglineVisible ? "translateY(0)" : "translateY(10px)",
              transition: animate
                ? "opacity 300ms ease, transform 300ms ease, background-color 160ms ease, border-color 160ms ease"
                : "background-color 160ms ease, border-color 160ms ease",
              "&:hover": {
                borderColor: colors.yellow[500],
                backgroundColor: "rgba(255, 177, 0, 0.08)",
              },
            }}
          >
            Explore FlowHub
          </Button>
        </Box>
      </Box>

      {/* Panel derecho con el formulario */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            width: "100%",
            maxWidth: "550px",
            px: { xs: 2, sm: 3 },
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
